<template>
  <div class="vz-page-loading-spinner" :class="{ 'vz-active': active }">
    <div class="vz-page-loading-spinner-spot">
      <i class="ic-loader vz-spin vz-page-loading-spinner-ic"></i>
    </div>
  </div>
</template>

<script>
/**
 * Shows/hides a loading spinner over all viewport.
 * @author Lanza
 */
export default {
  name: 'PageLoadingSpinner',

  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>














































<style theme="light-theater" scoped>
.vz-page-loading-spinner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  overflow: hidden;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  transition-property: height, opacity;
  transition-duration: 0s, 0.3s;
  transition-delay: 0.3s, 0s;
  z-index: 99990;
  background-image: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.65) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

.vz-page-loading-spinner.vz-active {
  height: 100%;
  opacity: 1;
  transition-delay: 0s, 0.5s;
}

.vz-page-loading-spinner-spot {
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.vz-page-loading-spinner-ic {
  position: relative;
  font-size: 20px;
  color: var(--primary-color);
}
</style>
